export default function Settings() {
  return (
    <div className="bg-white p-6 rounded-xl shadow">
      Settings
    </div>
  );
}
